/**
 * LinguistPro — tracks whether PayFast's onsite window is currently open.
 *
 * PaymentModal hides itself while PayFast's onsite window is open so that
 * window is the only thing the customer sees.
 */

import { useEffect, useState } from 'react';
import { isPayFastWindowOpen, watchPayFastWindow } from './onsitePayment';

export function usePayFastWindowOpen(): boolean {
  const [open, setOpen] = useState(() => isPayFastWindowOpen());

  useEffect(() => {
    return watchPayFastWindow(document, MutationObserver, setOpen);
  }, []);

  return open;
}
